import React, { useEffect, useState } from "react";
import { Badge, Button, Col, FormControl, FormSelect, Row, Stack, Table } from "react-bootstrap";
import { useLocation, Link } from "react-router-dom";
import WhiteObjectApi from "../../api/WhiteObjectApi";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ReportPDF from "./ReportPDF";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import csvDownload from "json-to-csv-export";
import Main from "../../components/layout/Main";
import Helmet from "react-helmet";
import { FaFilePdf, FaFileCsv } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
import DateRangePicker from 'rsuite/DateRangePicker';
// (Optional) Import component styles. If you are using Less, import the `index.less` file. 
import 'rsuite/DateRangePicker/styles/index.css';
import moment from "moment";
import PubSub from "pubsub-js";

const ReportView = () => {
  const [arrName, setArrName] = useState([]);
  const location = useLocation();
  const report = location.state;
  const [body, setBody] = useState([]);
  const [refreshList, setRefreshList] = useState(Date.now());
  const [values, setValues] = useState([]);
  const [fields, setFields] = useState([]);
  const [state, setState] = useState(location.state ? location.state : {});
  const getFilterInitialState = (apiName) => {
    console.log('REPORT API NAME',apiName)
    switch (apiName) {
      case 'supplier_report' :
        return { apiName: 'supplier_report' };
      case 'lead_source_report' :
        return { apiName: 'lead_source_report' };
      case 'PaymentReport' :
        return { apiName: 'PaymentReport' };
      case 'repair_ticket_report' :
        return { apiName: 'repair_ticket_report' };
      case 'due_payment_report' :
        return { apiName: 'due_payment_report' };
      case 'product_report' :
        return { apiName: 'product_report' };
      case 'month_wise_lead_report' :
        return { apiName: 'month_wise_lead_report' };
      case 'architect_report' :
        return { apiName: 'architect_report' };
      default:
        return null;
    }
  }
  const [filterData, setFilterData] = useState(getFilterInitialState(state.apiname));
  const [dateRange, setDateRange] = useState([]);
  async function init() {
    const result = await WhiteObjectApi.fetchReportsById(report, filterData);
    if (result && result.length) {
      setState(result[0])
      console.log("Fetched result:", result);
      const labels = labelList(Object.keys(result[0]));
      setArrName(labels);
      setBody(result);
    } else {
      setBody([]);
    }
  }
  useEffect(() => {
    console.log("state", state);
    dateRange?.length == 0 && init();
  }, [report, filterData]);

  async function fetchDataByDateRange() {
    console.log("first report YES", report);
    if (Array.isArray(dateRange)) {
      const [fromDate, toDate] = dateRange;
      if (fromDate && toDate) {
        const result = await WhiteObjectApi.fetchReportByDateRange(report, moment(fromDate).format("YYYY-MM-DD"), moment(toDate).format("YYYY-MM-DD"), filterData);
        console.log("first result", result);
        if (result?.error) {
          PubSub.publish("RECORD_ERROR_TOAST", {
            title: "Report",
            message: result?.error || "Some records found while fetch report",
          });
        } else if (result) {
          setBody(result);
        }
        else {
          setBody([]);
        }
      }
    } else {
      init();
    }
  }
  useEffect(() => {
    fetchDataByDateRange();
  }, [dateRange, filterData]);

  const labelList = (arry) => {
    return arry.map(date => {
      let label = date
        .split('_')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');

      return { label, name: date };
    });
  };

  const header = arrName.map(data => ({
    title: data.label,
    prop: data.name,
    isFilterable: true,
  }));

  const ReportDataCSV = {
    data: body,
    filename: "Report",
    delimiter: ",",
    headers: Object.keys(body[0] || {}),
  };

  const pdfRecorder = () => {
    setRefreshList(Date.now());
    setTimeout(pdf, 500);
  };

  const pdf = () => {
    const pdfTable = document.getElementById("divToPrint2");
    const html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true });
    const documentDefinition = {
      pageOrientation: 'landscape',
      content: [html],
      pageBreakBefore: currentNode => currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1,
    };
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.createPdf(documentDefinition).open();
  };

  const downloadPaymentCSV = ()=>{
    const data = [...body];
    data.push({ 
       "project_name": "",
      "leadname": "",
      "contactname": "",
      "projectmanagername": "",
      'project_total_amount' : data?.reduce((pre, current) => { return pre + (Number(current?.project_total_amount) || 0) }, 0)?.toFixed(2) || 0,
      'paidamount' : data?.reduce((pre, current) => { return pre + (Number(current?.paidamount) || 0) }, 0)?.toFixed(2) || 0,
      'pendingamount' : data?.reduce((pre, current) => { return pre + (Number(current?.pendingamount) || 0) }, 0)?.toFixed(2) || 0
    });
    
    const headers = Object.keys(data[0] || {});
    // headers?.push('total_amount','received_amount','pending_amount');
    const ReportDataCSV = {
      data: data,
      filename: "Report",
      delimiter: ",",
      headers: headers,
    };
    csvDownload(ReportDataCSV);
  }

  const handleFilterChange = (e) =>{
    const {name,value} = e.target;
    setFilterData((pre) => ({ ...pre, [name]:value }))
  }

  return (
    <Main>
      <Helmet>
        {/* <title>Report View</title> */}
      </Helmet>
      <Row className="g-0">
        <Col lg={4} className="mx-2">
          <Link to="/home" style={{ textDecoration: "none" }}>Home</Link>
          <BsChevronRight />
          <Link to="/reports" style={{ textDecoration: "none", marginLeft: "2px" }}>
            Reports <b>{report.name}</b>
          </Link>
        </Col>
        <Col lg={12} className="p-lg-4">
          {Array.isArray(body) ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{ initialState: { rowsPerPage: 20 } }}
            >
              <Row className="mb-4">
                <Col xs={2} lg={2} className="d-flex flex-col justify-content-end align-items-end">
                  <Filter />
                </Col>
                {report.apiname == 'supplier_report' &&
                  <Col xs={2} lg={2} className="d-flex flex-col justify-content-end align-items-end">
                    <FormSelect
                      name='status'
                      onChange={handleFilterChange}
                    >
                      <option value={''}>--select--</option>
                      {['pending', 'recieved', 'ordered'].map((value, index) => <option value={value} key={index}>{value}</option>)}
                    </FormSelect>
                  </Col>
                }
                {report.apiname == 'lead_source_report' &&
                  <Col xs={2} lg={2} className="d-flex flex-col justify-content-end align-items-end">
                    <FormControl
                      name='lead_source'
                      onChange={handleFilterChange}
                      placeholder="Enter lead source"
                    /> 
                  </Col>
                }
                <Col xs={2} sm={2} lg={2}>
                  <DateRangePicker
                    value={dateRange}
                    onChange={(e) => { setDateRange(e) }}
                    format="MM/dd/yyyy"
                    character=" – "
                  />
                </Col>
                {report.apiname == 'PaymentReport' &&
                  <Col xs={3} sm={3} lg={3} className="p-0 m-0 d-flex align-items-center">
                    <Stack direction="horizontal" gap={3} className="p-0 m-0 ">
                      <Badge><h6 className="m-0">Total Amount - ₹ {new Intl.NumberFormat("en-IN").format(body?.reduce((pre, current) => { return pre + (Number(current?.project_total_amount) || 0) }, 0)?.toFixed(2) || 0)}</h6></Badge>
                      <Badge bg="success"><h6 className="m-0">Received Amount - ₹ {new Intl.NumberFormat("en-IN").format(body?.reduce((pre, current) => { return pre + (Number(current?.paidamount) || 0) }, 0)?.toFixed(2) || 0)}</h6></Badge>
                      <Badge bg="danger"><h6 className="m-0">Pending Amount - ₹ {new Intl.NumberFormat("en-IN").format(body?.reduce((pre, current) => { return pre + (Number(current?.pendingamount) || 0) }, 0)?.toFixed(2) || 0)}</h6></Badge>
                    </Stack>
                  </Col>
                }
                <Col className="d-flex justify-content-end">
                  <Button className="btn-sm mr-2" variant="outline-success" onClick={() => { report.apiname == 'PaymentReport' ?  downloadPaymentCSV() : csvDownload(ReportDataCSV)}}>
                    <FaFileCsv style={{ fontSize: '24px' }} />
                  </Button>
                  <div style={{ width: '30px' }}></div>
                  {/* <Button className="btn-sm" variant="outline-danger" onClick={pdfRecorder}>
                    <FaFilePdf style={{ fontSize: '24px' }} />
                  </Button> */}
                </Col>
              </Row>
              <Table striped className="data-table" responsive="sm">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : null}
        </Col>
        <Col lg={2}></Col>
        <div className="App container mt-5" style={{ display: "none" }}>
          <div id="divToPrint2">
            <ReportPDF header={header} data={body} reportname={report.name} />
          </div>
        </div>
      </Row>
    </Main>
  );
};

export default ReportView;